import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { SalesService } from '../../core/sales/sales.service';
import * as _ from 'lodash';
import * as moment from "moment";
import { SalesDashboardBean } from "../../core/sales/sales-dashboard.model";
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'sales-chart',
  templateUrl: 'sales-chart.component.html',
  styleUrls: ['sales-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesChartComponent implements OnInit, AfterViewInit {

  salesAmountData: any; // Sales Amount Char Dataset
  salesAmountOptions: any; // Options for Sales Amount Charset
  salesCountData: any; // Sales Count Char Dataset
  salesCountOptions: any; // Options for Sales Count Charset
  errorSalesChart = false;
  salesChartErrorMessage = '';

  private isLoading: boolean = false;
  private startDate: Date;
  private endDate: Date;
  private queryDates: Date[] = [];

  constructor(private salesService: SalesService) {
    // to fill query dates on init, set current date -1
    const now = moment().subtract(1, 'days').toDate();
    this.startDate = now;
    this.endDate = now;
    this.queryDates = [now, now];
  }

  ngOnInit(): void {
    this.errorSalesChart = false;
  }

  ngAfterViewInit(): void {
    this.updateSalesDashboard();
  }

  invalidDateRange(): boolean {
    return _.isNil(this.queryDates[0]) ||
      _.isNil(this.queryDates[1]);
  }

  updateSalesDashboard(): void {
    this.isLoading = true;
    // get information from Sales Service
    this.salesService.getSalesDashboard(this.queryDates)
      .finally(() => this.isLoading = false)
      .subscribe(
        response => {
          this.startDate = this.queryDates[0];
          this.endDate = this.queryDates[1];
          this.errorSalesChart = false;
          // after get information from sales service, fill Charts
          this.fillAmountSalesDashboardChart(response);
          this.fillCountSalesDashboardChart(response);
        },
        error => {
          console.error('error: ', error);
          this.errorSalesChart = true;
          this.salesChartErrorMessage = error;
        }
      );
  }

  fillAmountSalesDashboardChart(salesDashboard: SalesDashboardBean) {
    // build chart
    let curr = new CurrencyPipe("en-US"); // build currency pipe to format data
    this.salesAmountData = {
      labels: ['Melate', 'Melate Retro', 'Chispazo', 'Tris', 'Progol', 'Progol Media Semana'],
      datasets: [
        {
          label: 'Ventas Totales: ' + curr.transform(salesDashboard.totalAmount),
          //backgroundColor: '#ff7000', // ganalottodo colors
          //borderColor: '#ff7000',
          data: [salesDashboard.totalMelateAmount,
          salesDashboard.totalMelateRetroAmount,
          salesDashboard.totalChispazoAmount,
          salesDashboard.totalTrisAmount,
          salesDashboard.totalProgolAmount,
          salesDashboard.totalProgolMSAmount],
          backgroundColor: [
            "#EE0000",
            "#8819FF",
            "#F39907",
            "#0A59FF",
            "#FF7000",
            "#60BB40"
          ],
          hoverBackgroundColor: [
            "#EE0000",
            "#8819FF",
            "#F39907",
            "#0A59FF",
            "#FF7000",
            "#60BB40"
          ]
        },
      ]
    };
    // chart options
    this.salesAmountOptions = {
      scales: { // currency format to Y values
        yAxes: [{
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return curr.transform(value);
            }
          }
        }]
      },
      tooltips: { // currency format to values in tooltips
        "enabled": false, // because we need to display amount on top of bar, disable tooltips
        callbacks: {
          label: function (tooltipItem, chart) {
            var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
            return datasetLabel + curr.transform(tooltipItem.yLabel);
          }
        }
      },
      // display amount values on top of bar
      "hover": {
        "animationDuration": 0
      },
      "animation": {
        "duration": 1,
        "onComplete": function () {
          var chartInstance = this.chart,
            ctx = chartInstance.ctx;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';
          // set amount on top for each value in dataset
          this.data.datasets.forEach(function (dataset, i) {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
              var data = curr.transform(dataset.data[index]);
              ctx.fillText(data, bar._model.x, bar._model.y - 5);
            });
          });
        }
      }

    };
  }

  fillCountSalesDashboardChart(salesDashboard: SalesDashboardBean) {
    // build chart
    this.salesCountData = {
      labels: ['Melate', 'Melate Retro', 'Chispazo', 'Tris', 'Progol', 'Progol Media Semana'],
      datasets: [
        {
          label: 'Conteo por Juego',
          //backgroundColor: '#ff7000', // games colors
          //borderColor: '#ff7000',
          data: [salesDashboard.totalMelateCount,
          salesDashboard.totalMelateRetroCount,
          salesDashboard.totalChispazoCount,
          salesDashboard.totalTrisCount,
          salesDashboard.totalProgolCount,
          salesDashboard.totalProgolMSCount],
          backgroundColor: [
            "#EE0000",
            "#8819FF",
            "#F39907",
            "#0A59FF",
            "#FF7000",
            "#60BB40"
          ],
          hoverBackgroundColor: [
            "#EE0000",
            "#8819FF",
            "#F39907",
            "#0A59FF",
            "#FF7000",
            "#60BB40"
          ]
        },
      ]
    };

    this.salesCountOptions = {
      title: {
        display: true,
        text: '# De juegos vendidos: ' + salesDashboard.totalCount,
        //fontSize: 16
      },
      legend: {
        position: 'bottom'
      }
    };

  }

}


// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/sales/sales-chart.component.ts